import { GridCustomCellProps } from '@progress/kendo-react-grid';
import { openWindowPerc } from '../../services/openWindow';
import { OrderServiceExceptionViewModel } from 'TypeGen/ServiceExceptions/order-service-exception-view-model';

export const FailureReasonCell = (props: GridCustomCellProps) => {
  const dataItem = props.dataItem as OrderServiceExceptionViewModel;
  return <td {...props.tdProps}>
    <a
      href="#"
      style={{ color: '#007bff' }}
      onClick={(e) => {
        openWindowPerc(`/Order/${dataItem.OrderID}/ServiceException/${dataItem.OrderServiceExceptionID}`);
        e.preventDefault();
      }}
    >
      {dataItem.FailureReasonName}
    </a>
  </td>
}